<template>
  <b-modal
    ref="modal"
    v-model="isShown"
    :title="$t('views.file_list.add_file')"
    modal-class="spso-modal"
    hide-header-close
    hide-footer
    centered
    size="lg"
    @hidden="hideModal"
  >
    <v-form
      ref="form"
      @submit.prevent="submit"
    >
      <div class="v-application spso-modal__body pt-0">
        <div class="mt-8 mb-3">
          <input
            v-show="false"
            ref="file"
            type="file"
            @change="setFile"
          >
          <button
            type="button"
            :disabled="loading"
            class="btn spso-button spso-button_line spso-button_lowercase file-list__select-file"
            @click="selectFile"
          >
            {{ $t('views.file_list.select_file') }}
          </button>
          <span
            v-if="file"
            class="file-list__selected-file"
          >
            {{ file.name }}
          </span>
        </div>
        <div class="input-block input-block_white">
          <label class="input-block__label">
            {{ $t('views.file_list.description') }}
          </label>
          <v-text-field
            v-model.number="item.description"
            solo
            hide-details
          />
        </div>
      </div>

      <div class="v-application d-flex">
        <v-btn
          class="mr-4 flex-grow-1"
          outlined
          large
          :disabled="loading"
          @click="hideModal"
        >
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          class="flex-grow-1"
          :loading="loading"
          :disabled="!file"
          outlined
          large
          type="submit"
        >
          {{ $t('common.add') }}
        </v-btn>
      </div>
    </v-form>
  </b-modal>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'FileAdding',

  model: {
    prop: 'value',
  },

  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      EMPTY_VALUE: {
        blobName: '',
        type: '',
        name: '',
        description: '',
      },

      item: { ...this.EMPTY_VALUE },
      file: null,

      loading: false,
      isShown: false,
    };
  },

  watch: {
    value(val) {
      this.isShown = val;
      if (val) {
        this.item = { ...this.EMPTY_VALUE };
        this.file = null;
      }
    },
  },

  methods: {
    hideModal() {
      this.$emit('input', false);
    },

    selectFile() {
      this.$refs.file.value = null;
      this.$refs.file.click();
    },

    setFile() {
      [this.file] = this.$refs.file.files;
    },

    async submit() {
      this.loading = true;
      try {
        this.item.type = this.file.type;
        this.item.name = this.file.name;
        this.item.blobName = await this.uploadFile();
        if (this.item.blobName) {
          await this.$http.post('/files', this.item);
          this.hideModal();
          this.$emit('submit');
        }
        this.$refs.file.value = null;
        this.file = null;
      } catch (err) {
        this.$http.mockApiError(err);
      } finally {
        this.loading = false;
      }
    },

    async uploadFile() {
      const blobName = uuidv4();
      const { type } = this.file;
      const fileData = await this.getFileData();
      try {
        await this.$http.post('/containers/file', fileData, {
          headers: { container: this.$config.COMMON_FILES_CONTAINER, file: blobName, 'Content-Type': type },
        });
        return blobName;
      } catch (err) {
        this.$http.mockApiError(err);
      }

      return null;
    },

    getFileData() {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.readAsArrayBuffer(this.file);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.file-list__select-file {
  margin-right: 20px;
  padding: 12px 25px;
}

.file-list__selected-file {
  color: var(--topaz);
}
</style>
